import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) =>
  (conversationID: number, toFavor: boolean) =>
    makeCall(
      'PUT',
      `${APIV2_URL}/conversation/${conversationID}/${
        toFavor ? 'favorite' : 'unfavorite'
      }`,
    );
